import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { RULE_QUERY_KEYS } from 'app/modules/rules/queries/keys';
import { DetectionModel } from 'app/modules/detectionModels/models';
import { useSelector } from 'react-redux';
import { selectHasReadRulesPermission } from 'app/modules/session/selectors';
import { RuleStatuses } from 'app/modules/rules/models';

const fetchRule = (
  ruleId: number,
  ruleStatus: RuleStatuses,
): Promise<DetectionModel> => {
  if (ruleStatus === RuleStatuses.VALIDATION) {
    const path = `/detection-models/validation/${ruleId}`;
    return get(path);
  }
  const path = `/detection-models/${ruleId}`;
  return get(path);
};

export const useFetchRule = (ruleId: number, ruleStatus: RuleStatuses) => {
  const hasReadRulePermission = useSelector(selectHasReadRulesPermission);
  return useQuery({
    queryKey: RULE_QUERY_KEYS.getRule(ruleId, ruleStatus),
    queryFn: () => fetchRule(ruleId, ruleStatus),
    enabled: hasReadRulePermission && ruleId > 0,
  });
};
